/* Fabric Alex global storefront fixes. */
(function () {
  'use strict';

  var chatSelectors = [
    '#dummy-chat-button',
    '#dummy-chat-button-iframe',
    '.otFacbookChat',
    '#fb-customer-chat',
    '.fb-customerchat',
    '[id*="omega-chat"]',
    '[class*="omega-chat"]',
    '[id*="omg-facebook-chat"]',
    '[class*="omg-facebook-chat"]',
    '[id*="omegaMessenger"]',
    '[class*="omegaMessenger"]'
  ];

  var NEW_PHONE_DISPLAY = '052 920 123';
  var NEW_PHONE_HREF = 'tel:052920123';
  var OLD_PHONE_DIGITS = '888517804';
  var oldPhonePattern = /(?:\+?359|0)[\s.\-]*888[\s.\-]*517[\s.\-]*804/g;
  var CHECKOUT_STYLE_ID = 'fa-checkout-handoff-style';
  var cartQuantityFallbackInstalled = false;

  function normalizePhone(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function updatePhoneLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="tel:"]'), function (link) {
      var digits = normalizePhone(link.getAttribute('href'));
      if (digits.indexOf(OLD_PHONE_DIGITS) === -1) return;

      link.setAttribute('href', NEW_PHONE_HREF);

      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var value = node.nodeValue || '';
        oldPhonePattern.lastIndex = 0;
        if (oldPhonePattern.test(value)) {
          oldPhonePattern.lastIndex = 0;
          node.nodeValue = value.replace(oldPhonePattern, NEW_PHONE_DISPLAY);
        }
      }

      if (link.classList.contains('fa-contact__channel--phone')) {
        var small = link.querySelector('small');
        if (small) small.textContent = NEW_PHONE_DISPLAY;
        link.setAttribute('aria-label', NEW_PHONE_DISPLAY);
      }
    });
  }

  function installHideStyle() {
    if (document.getElementById('fa-disable-floating-chat')) return;
    var style = document.createElement('style');
    style.id = 'fa-disable-floating-chat';
    style.textContent = chatSelectors.join(',') + ',iframe[src*="omegatheme.com"],iframe[src*="omega-chat"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;width:0!important;height:0!important;min-width:0!important;min-height:0!important;max-width:0!important;max-height:0!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function installCheckoutHandoffStyle() {
    if (document.getElementById(CHECKOUT_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = CHECKOUT_STYLE_ID;
    style.textContent = [
      '.template-cart .page__header .page__description,.template-cart .empty-state__description,#mini-cart .mini-cart__alert-wrapper{display:none!important;}',
      '.template-cart .estimate-shipping,.template-cart .card:has(> .estimate-shipping){display:none!important;}',
      '.fa-checkout-handoff{position:relative;isolation:isolate;margin:0 0 17px;padding:16px;border:1px solid rgba(11,42,73,.11);border-radius:17px;overflow:hidden;background:linear-gradient(145deg,rgba(255,255,255,.92),rgba(247,239,229,.82));box-shadow:0 11px 30px rgba(11,42,73,.065);}',
      '.fa-checkout-handoff:before{content:"";position:absolute;z-index:-1;width:150px;height:150px;right:-75px;top:-85px;border-radius:999px;background:radial-gradient(circle,rgba(127,23,53,.14),transparent 70%);pointer-events:none;}',
      '.fa-checkout-handoff__eyebrow{display:flex;align-items:center;gap:7px;margin:0 0 10px;color:#7f1735;font-size:10px;font-weight:900;letter-spacing:.11em;text-transform:uppercase;}',
      '.fa-checkout-handoff__eyebrow:before{content:"";width:7px;height:7px;border-radius:50%;background:#d69b3e;box-shadow:0 0 0 4px rgba(214,155,62,.13);}',
      '.fa-checkout-handoff__top{display:grid;grid-template-columns:39px minmax(0,1fr);gap:10px;align-items:center;}',
      '.fa-checkout-handoff__icon{display:grid;width:39px;height:39px;place-items:center;border-radius:12px;color:#fff;background:linear-gradient(135deg,#0b3d63,#7f1735);font-size:18px;font-weight:900;}',
      '.fa-checkout-handoff__title{display:block;color:#0b2a49;font-size:15px;font-weight:900;line-height:1.2;}',
      '.fa-checkout-handoff__lead{display:block;margin-top:2px;color:#40566b;font-size:11.5px;font-weight:750;line-height:1.35;}',
      '.fa-checkout-handoff__window{display:grid;grid-template-columns:minmax(0,1fr) 26px minmax(0,1fr);gap:6px;align-items:center;margin-top:13px;}',
      '.fa-checkout-handoff__date{display:grid;gap:2px;min-width:0;padding:9px 10px;border:1px solid rgba(11,61,99,.12);border-radius:12px;background:rgba(255,255,255,.72);}',
      '.fa-checkout-handoff__date--second{border-color:rgba(127,23,53,.14);background:rgba(252,244,241,.78);}',
      '.fa-checkout-handoff__day{overflow:hidden;color:#0b3d63;font-size:10px;font-weight:850;line-height:1.2;text-overflow:ellipsis;white-space:nowrap;}',
      '.fa-checkout-handoff__date--second .fa-checkout-handoff__day{color:#7f1735;}',
      '.fa-checkout-handoff__date-value{color:#0b2a49;font-size:13px;font-weight:900;line-height:1.2;}',
      '.fa-checkout-handoff__to{display:grid;place-items:center;color:#7b8793;font-size:9px;font-weight:900;text-transform:uppercase;}',
      '.fa-checkout-handoff__note{margin:10px 0 0;color:#40566b;font-size:10.8px;font-weight:700;line-height:1.4;}',
      '.fa-checkout-handoff__couriers{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:11px;padding-top:10px;border-top:1px solid rgba(11,42,73,.08);color:#3d556b;font-size:11px;font-weight:750;}',
      '.fa-checkout-handoff__couriers strong{color:#0b2a49;font-size:10.5px;}',
      '.fa-checkout-handoff__steps{display:flex;gap:5px;margin:11px 0 0;padding:0;list-style:none;}',
      '.fa-checkout-handoff__step{flex:1;min-width:0;padding:6px 4px;border-radius:999px;background:rgba(11,42,73,.055);color:#52687d;font-size:9.5px;font-weight:850;text-align:center;white-space:nowrap;}',
      '.fa-checkout-handoff__step:first-child{color:#7f1735;background:rgba(127,23,53,.09);}',
      '.template-cart .cart-recap__checkout,.template-cart .page__button-action,#mini-cart button[name="checkout"]{position:relative;overflow:hidden;border-radius:14px!important;background:linear-gradient(115deg,#082b4f 0%,#103d67 48%,#8f102b 100%)!important;border-color:transparent!important;box-shadow:0 12px 24px rgba(8,43,79,.18);font-weight:850!important;letter-spacing:.01em;transition:transform .2s ease,box-shadow .2s ease,filter .2s ease;}',
      '.template-cart .cart-recap__checkout:hover,.template-cart .page__button-action:hover,#mini-cart button[name="checkout"]:hover{transform:translateY(-1px);box-shadow:0 16px 30px rgba(8,43,79,.24);filter:saturate(1.08);}',
      '.template-cart .cart-recap__checkout:focus-visible,.template-cart .page__button-action:focus-visible,#mini-cart button[name="checkout"]:focus-visible{outline:3px solid rgba(232,95,82,.35);outline-offset:3px;}',
      '.fa-mini-delivery{margin:0 0 12px;padding:10px 11px;border:1px solid rgba(8,43,79,.1);border-radius:14px;background:linear-gradient(135deg,rgba(185,217,234,.22),rgba(251,247,239,.82));}',
      '.fa-mini-delivery__title{display:flex;align-items:center;gap:6px;margin:0;color:#082b4f;font-size:11px;font-weight:850;line-height:1.25;}.fa-mini-delivery__title:before{content:"";width:7px;height:7px;border-radius:50%;background:#e85f52;}',
      '.fa-mini-delivery__methods{margin:4px 0 0;color:#596b7d;font-size:10px;font-weight:700;line-height:1.35;}.fa-mini-delivery__note{margin:3px 0 0;color:#7b8795;font-size:9.5px;line-height:1.35;}',
      '@media screen and (max-width:640px){.fa-checkout-handoff{padding:14px;border-radius:15px}.fa-checkout-handoff__title{font-size:14px}.fa-checkout-handoff__date{padding:8px}.fa-checkout-handoff__date-value{font-size:12px}.template-cart .page__button-action{margin-top:6px!important}}',
      '@media (prefers-reduced-motion:reduce){.template-cart .cart-recap__checkout,.template-cart .page__button-action,#mini-cart button[name="checkout"]{transition:none!important}}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function isBulgarian() {
    return /^bg(?:-|$)/i.test(document.documentElement.getAttribute('lang') || '');
  }

  function checkoutCopy() {
    if (isBulgarian()) {
      return {
        eyebrow: 'Бърза доставка в България',
        title: 'Очаквана доставка',
        lead: 'Поръчайте сега и вижте реалния прозорец за доставка',
        tomorrow: 'Утре',
        rangeTo: 'до',
        beforeCutoff: 'Поръчайте до 14:00 за този прозорец',
        afterCutoff: 'След 14:00 · показваме следващия наличен прозорец',
        sunday: 'Неделя е неработен ден · показваме следващите работни дни',
        couriers: 'Speedy и Econt',
        courierDetail: 'До офис или адрес',
        steps: ['Количка', 'Доставка', 'Плащане'],
        cta: 'Продължи към доставка',
        miniTitle: 'Бърза доставка в България',
        miniMethods: 'Speedy · Econt · офис или адрес',
        miniNote: 'Финалната цена се показва на следващата стъпка.'
      };
    }

    return {
      eyebrow: 'Fast delivery across Bulgaria',
      title: 'Estimated delivery',
      lead: 'Order now to secure the earliest available delivery window',
      tomorrow: 'Tomorrow',
      rangeTo: 'to',
      beforeCutoff: 'Order by 14:00 for this delivery window',
      afterCutoff: 'After 14:00 · showing the next available window',
      sunday: 'Sunday is non-working · showing the next working days',
      couriers: 'Speedy and Econt',
      courierDetail: 'Office pickup or delivery to your address',
      steps: ['Cart', 'Delivery', 'Payment'],
      cta: 'Continue to delivery',
      miniTitle: 'Fast delivery across Bulgaria',
      miniMethods: 'Speedy · Econt · office or address',
      miniNote: 'The final delivery price is shown on the next step.'
    };
  }

  function makeTextElement(tagName, className, text) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    el.textContent = text;
    return el;
  }

  function addDeliveryDays(date, amount) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + amount);
    return next;
  }

  function isDeliverySunday(date) {
    return date.getUTCDay() === 0;
  }

  function nextDeliveryWorkingDay(date) {
    var next = addDeliveryDays(date, 1);
    while (isDeliverySunday(next)) next = addDeliveryDays(next, 1);
    return next;
  }

  function deliverySofiaClock() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Sofia',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = part.value; });
      return { date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))), hour: Number(values.hour) };
    } catch (error) {
      var now = new Date();
      return { date: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())), hour: now.getHours() };
    }
  }

  function deliveryDateText(date) {
    function pad(value) { return String(value).padStart(2, '0'); }
    return pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.' + date.getUTCFullYear();
  }

  function deliveryWeekdayText(date) {
    var daysBg = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
    var daysEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return (isBulgarian() ? daysBg : daysEn)[date.getUTCDay()];
  }

  function cartDeliveryEstimate(copy) {
    var clock = deliverySofiaClock();
    var today = clock.date;
    var afterCutoff = !isDeliverySunday(today) && clock.hour >= 14;
    var first = nextDeliveryWorkingDay(today);
    if (afterCutoff) first = nextDeliveryWorkingDay(first);
    var second = nextDeliveryWorkingDay(first);
    return {
      firstDay: deliveryWeekdayText(first),
      firstDate: deliveryDateText(first),
      secondDay: deliveryWeekdayText(second),
      secondDate: deliveryDateText(second),
      note: isDeliverySunday(today) ? copy.sunday : (afterCutoff ? copy.afterCutoff : copy.beforeCutoff)
    };
  }

  function buildCheckoutHandoff(copy) {
    var estimate = cartDeliveryEstimate(copy);
    var panel = document.createElement('section');
    panel.className = 'fa-checkout-handoff';
    panel.setAttribute('data-fa-checkout-handoff', 'true');
    panel.setAttribute('aria-label', copy.eyebrow);

    panel.appendChild(makeTextElement('p', 'fa-checkout-handoff__eyebrow', copy.eyebrow));

    var top = document.createElement('div');
    top.className = 'fa-checkout-handoff__top';
    top.appendChild(makeTextElement('span', 'fa-checkout-handoff__icon', '↗'));
    var heading = document.createElement('span');
    heading.appendChild(makeTextElement('strong', 'fa-checkout-handoff__title', copy.title));
    heading.appendChild(makeTextElement('span', 'fa-checkout-handoff__lead', copy.lead));
    top.appendChild(heading);
    panel.appendChild(top);

    var windowRow = document.createElement('div');
    windowRow.className = 'fa-checkout-handoff__window';
    [['first', estimate.firstDay, estimate.firstDate], ['second', estimate.secondDay, estimate.secondDate]].forEach(function (entry, index) {
      if (index === 1) windowRow.appendChild(makeTextElement('span', 'fa-checkout-handoff__to', copy.rangeTo));
      var card = document.createElement('span');
      card.className = 'fa-checkout-handoff__date fa-checkout-handoff__date--' + entry[0];
      card.appendChild(makeTextElement('span', 'fa-checkout-handoff__day', entry[1]));
      card.appendChild(makeTextElement('strong', 'fa-checkout-handoff__date-value', entry[2]));
      windowRow.appendChild(card);
    });
    panel.appendChild(windowRow);
    panel.appendChild(makeTextElement('p', 'fa-checkout-handoff__note', estimate.note));

    var couriers = document.createElement('div');
    couriers.className = 'fa-checkout-handoff__couriers';
    couriers.appendChild(makeTextElement('strong', '', copy.couriers));
    couriers.appendChild(makeTextElement('span', '', copy.courierDetail));
    panel.appendChild(couriers);

    var steps = document.createElement('ol');
    steps.className = 'fa-checkout-handoff__steps';
    copy.steps.forEach(function (label, index) {
      var item = makeTextElement('li', 'fa-checkout-handoff__step', (index + 1) + '. ' + label);
      if (index === 0) item.setAttribute('aria-current', 'step');
      steps.appendChild(item);
    });
    panel.appendChild(steps);
    return panel;
  }

  function setCheckoutButtonLabel(button, label) {
    if (!button || button.getAttribute('data-fa-checkout-label') === label) return;
    button.setAttribute('data-fa-checkout-label', label);
    button.setAttribute('aria-label', label);
    button.textContent = label + '  →';
  }

  function enhanceCartCheckout() {
    var recap = document.querySelector('.template-cart .cart-recap');
    if (!recap) return;

    var copy = checkoutCopy();
    var cardSection = recap.querySelector('.card__section') || recap;
    if (!recap.querySelector('[data-fa-checkout-handoff="true"]')) {
      cardSection.insertBefore(buildCheckoutHandoff(copy), cardSection.firstChild);
    }

    Array.prototype.forEach.call(document.querySelectorAll('.template-cart button[name="checkout"]'), function (button) {
      setCheckoutButtonLabel(button, copy.cta);
    });
  }

  function enhanceMiniCartCheckout() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || !miniCart.querySelector('.mini-cart__recap')) return;

    var copy = checkoutCopy();
    var recap = miniCart.querySelector('.mini-cart__recap');
    if (!recap.querySelector('[data-fa-mini-delivery="true"]')) {
      var compact = document.createElement('div');
      compact.className = 'fa-mini-delivery';
      compact.setAttribute('data-fa-mini-delivery', 'true');
      compact.appendChild(makeTextElement('p', 'fa-mini-delivery__title', copy.miniTitle));
      compact.appendChild(makeTextElement('p', 'fa-mini-delivery__methods', copy.miniMethods));
      compact.appendChild(makeTextElement('p', 'fa-mini-delivery__note', copy.miniNote));

      var buttonContainer = recap.querySelector('.mini-cart__button-container');
      recap.insertBefore(compact, buttonContainer || recap.firstChild);
    }

    setCheckoutButtonLabel(miniCart.querySelector('button[name="checkout"]'), copy.cta);
  }

  function installCartQuantityFallback() {
    if (cartQuantityFallbackInstalled || !document.querySelector('.template-cart [data-section-type="cart"]')) return;
    cartQuantityFallbackInstalled = true;

    document.addEventListener('click', function (event) {
      var origin = event.target && event.target.closest ? event.target : null;
      var control = origin ? origin.closest('.template-cart [data-action="increase-quantity"],.template-cart [data-action="decrease-quantity"]') : null;
      if (!control || control.disabled || control.closest('[data-fa-cart-length]')) return;

      var lineId = control.getAttribute('data-line-id');
      var quantity = parseInt(control.getAttribute('data-quantity'), 10);
      var fallbackUrl = control.getAttribute('data-href') || control.getAttribute('href');
      if (!lineId || !isFinite(quantity)) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      var row = control.closest('.line-item');
      if (row && row.classList.contains('is-updating')) return;
      if (row) row.classList.add('is-updating');

      Array.prototype.forEach.call((row || document).querySelectorAll('[data-action="increase-quantity"],[data-action="decrease-quantity"]'), function (button) {
        button.setAttribute('aria-disabled', 'true');
      });

      var endpoint = (window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : '/cart/change') + '.js';
      fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineId, quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        if (fallbackUrl) {
          window.location.assign(fallbackUrl);
          return;
        }
        if (row) row.classList.remove('is-updating');
      });
    }, true);
  }

  function removeOmegaChat() {
    installHideStyle();

    chatSelectors.forEach(function (selector) {
      var nodes;
      try { nodes = document.querySelectorAll(selector); } catch (error) { nodes = []; }
      Array.prototype.forEach.call(nodes, function (node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('iframe[src]'), function (frame) {
      var src = (frame.getAttribute('src') || '').toLowerCase();
      if (src.indexOf('omegatheme.com') !== -1 || src.indexOf('omega-chat') !== -1 || src.indexOf('facebook-chat-1') !== -1) {
        if (frame.parentNode) frame.parentNode.removeChild(frame);
      }
    });
  }

  function runGlobalFixes() {
    removeOmegaChat();
    updatePhoneLinks();
    installCartQuantityFallback();
    enhanceCartCheckout();
    enhanceMiniCartCheckout();
  }

  installHideStyle();
  installCheckoutHandoffStyle();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runGlobalFixes);
  } else {
    runGlobalFixes();
  }

  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      runGlobalFixes();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(runGlobalFixes, 300);
  window.setTimeout(runGlobalFixes, 1000);
  window.setTimeout(runGlobalFixes, 2500);
})();